function saveToLocalStorage(name: string, data: unknown) {
  try {
    const stringifiedData = JSON.stringify(data);
    localStorage.setItem(name, stringifiedData);
    return true;
  } catch (error) {
    return false;
  }
}

function getFromLocalStorage(name: string) {
  try {
    const data = localStorage.getItem(name);
    const parsedData = JSON.parse(data!);
    return parsedData;
  } catch (error) {
    return false;
  }
}

function deleteFromLocalStorage(name: string) {
  try {
    localStorage.removeItem(name);
    return true;
  } catch (error) {
    return false;
  }
}

function clearLocalStorage() {
  deleteFromLocalStorage('activeFilters');
  deleteFromLocalStorage('activeTabs');
  deleteFromLocalStorage('activeTabsMapping');
  deleteFromLocalStorage('activeSearch');
  deleteFromLocalStorage('activeOperator');
  deleteFromLocalStorage('activeEnv');
  deleteFromLocalStorage('tableConfigs');
  deleteFromLocalStorage('productsListColumns');
  deleteFromLocalStorage('productBalancesColumns');
  deleteFromLocalStorage('campaignsListColumns');
  deleteFromLocalStorage('campaignProductsListColumns');
  deleteFromLocalStorage('overrideSearch');
  deleteFromLocalStorage('activeChain');
  deleteFromLocalStorage('activeService');
  deleteFromLocalStorage('assortmentListActiveFilters');
  deleteFromLocalStorage('supplementOrdersProductSearchFilters');
  deleteFromLocalStorage('supplementOrdersProductSearchOperator');
  deleteFromLocalStorage('nosProductSearchFilters');
  deleteFromLocalStorage('nosProductSearchOperator');
  deleteFromLocalStorage('supplementOrdersCart');
  deleteFromLocalStorage('userShop');
}

export { saveToLocalStorage, getFromLocalStorage, deleteFromLocalStorage, clearLocalStorage };
